import {
  GAME_ID,
  APP_PAGES,
  LOAD_PROGRESS_PAGE,
  LOAD_LEVEL_SUMMARY_PAGE,
  LOAD_ONBOARDING_PAGE,
  LOAD_STANDARD_PAGE,
  LOAD_INSTRUCTION_PAGE,
  LOAD_LOADING_PAGE,
} from '../foodTruckConstants';

const initialState = {
  currentPage: APP_PAGES.LOADING,
  menuMode: false,
  onboardingMode: false,
  standardMode: false,
  instructionMode: false,
  onboardingForced: false,
};

// pretty straightforward: navigate through main pages
const foodTruckNavigationReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case LOAD_PROGRESS_PAGE: {
      return {
        ...initialState,
        currentPage: APP_PAGES.PROGRESS,
        menuMode: true,
      };
    }
    case LOAD_LEVEL_SUMMARY_PAGE: {
      return {
        ...initialState,
        currentPage: APP_PAGES.LEVEL_SUMMARY,
        menuMode: true,
      };
    }
    case LOAD_ONBOARDING_PAGE: {
      return {
        ...initialState,
        currentPage: APP_PAGES.ONBOARDING,
        onboardingMode: true,
        onboardingForced: action.payload.isForced,
      };
    }
    case LOAD_STANDARD_PAGE: {
      return {
        ...initialState,
        currentPage: APP_PAGES.STANDARD,
        standardMode: true,
      };
    }
    case LOAD_INSTRUCTION_PAGE: {
      return {
        ...initialState,
        currentPage: APP_PAGES.INSTRUCTION,
        instructionMode: true,
      };
    }
    case LOAD_LOADING_PAGE: {
      return {
        ...initialState,
        currentPage: APP_PAGES.LOADING,
        onboardingForced: state.onboardingForced,
      };
    }
    default:
      return state;
  }
};

export default foodTruckNavigationReducer;
